(() => {
  // app/scripts/functions/ymmUtilsTeifi.js
  var SORT_OUT_OF_STOCK_AT_END = true;
  var ymmOptions = {
    appName: "ymm",
    shopName: "modula-racks"
  };
  function floatEqual(a, b) {
    return Math.abs(parseInt(a) - parseInt(b)) < 1e-3;
  }
  function getSortQuery(container) {
    const sort = [];
    if (SORT_OUT_OF_STOCK_AT_END) {
      sort.push({
        "variants.availableForSale": {
          mode: "max",
          order: "desc",
          nested: {
            path: "variants"
          }
        }
      });
    }
    const sortElement = document.querySelector('[name="ymm_sort"]');
    const collectionDefaultSortBy = document.getElementById("ymm-collection-info")?.dataset.collectionDefaultSortBy;
    if (!sortElement)
      return void 0;
    const type = sortElement.value;
    const order = type.includes("ascending") ? "asc" : "desc";
    const collectionId = container?.dataset?.collectionId?.trim();
    if (type.includes("price")) {
      sort.push({
        "variants.price": {
          mode: "avg",
          order,
          nested: {
            path: "variants"
          }
        }
      });
      return sort;
    } else if (type.includes("title")) {
      sort.push({ title: { order } });
      return sort;
    } else if (type.includes("created")) {
      sort.push({ createdAt: { order } });
      return sort;
    } else if (type.includes("manual") && collectionId != null && collectionId !== "") {
      sort.push({
        "metafields.ymma_order.value": {
          order: "asc",
          nested: {
            path: "metafields.ymma_order"
          }
        }
      });
      return sort;
    }
    return sort;
  }
  function getYMMFilters(container) {
    const variantsSelectedOptions = {};
    const variantMetafieldOptions = {};
    const productMetafields = {};
    const variantsPrice = {};
    const fitments = [];
    const productTypes = [];
    const vendor = [];
    for (const el of document.querySelectorAll(".jsYMMParams")) {
      const { filterType, filterOptionName } = el.closest("[data-filter-type]").dataset;
      switch (filterType) {
        case "variant_option":
          if (el.type !== "checkbox" || !el.checked)
            continue;
          addOptionValues(filterOptionName, el.value, variantsSelectedOptions);
          break;
        case "variant_metafield":
          if (el.type !== "checkbox" || !el.checked)
            continue;
          addOptionValues(filterOptionName, el.value, variantMetafieldOptions);
          break;
        case "variant_price":
          const { name, value } = el;
          let n = void 0;
          if (value.trim() !== "") {
            const v = Number(value);
            const bound = Number(name === "gte" ? el.getAttribute("min") : el.getAttribute("max"));
            if (!floatEqual(v, bound)) {
              n = v;
            }
          }
          variantsPrice[el.name] = n;
          break;
        case "fitment":
          if (!el.checked)
            continue;
          fitments.push(el.value);
          break;
        case "product_type":
          if (!el.checked)
            continue;
          productTypes.push(el.value);
          break;
        case "product_vendor":
          if (!el.checked)
            continue;
          vendor.push(el.value);
          break;
        case "product_variant":
          if (el.type !== "checkbox" || !el.checked)
            continue;
          addOptionValues(filterOptionName, el.value, productMetafields);
          break;
        default:
          console.error("Unhandled filter element", el);
      }
    }
    if (window.ymmFitmentFirstLoad && Object.keys(YMM.getYMMValue()).length) {
      fitments.push("Universal");
    }
    if (container.dataset.vehicleSpec == "true") {
      fitments.push("Vehicle Specific");
    }
    return { variantsSelectedOptions, variantMetafieldOptions, variantsPrice, fitments, productTypes, vendor, productMetafields };
    function addOptionValues(key, value, object) {
      const selectedOptions = object[key] ?? [];
      if (!selectedOptions.includes(value)) {
        selectedOptions.push(value);
      }
      object[key] = selectedOptions;
    }
  }
  var YMM = {
    ymmAPI: (body) => {
      return new Promise((resolve, reject) => {
        fetch(`/apps/${ymmOptions.appName}/api/elastic/products-${ymmOptions.shopName}/_search`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        }).then((res) => res.json()).then((res) => resolve(res)).catch((error) => reject(error));
      });
    },
    getYMMValue: () => {
      const ymm = {};
      for (const name of ["year", "make", "model"]) {
        const value = localStorage.getItem(`ymm-${name}`);
        if (value == null || value.trim() === "")
          continue;
        ymm[name] = value;
      }
      return ymm;
    },
    ymmSave: (array = null) => {
      (array || (void 0).querySelectorAll("select")).forEach((select) => {
        const name2 = select.getAttribute("name");
        const key2 = `ymm-${name2}`;
        const value2 = String(select.value);
        localStorage.setItem(key2, value2);
      });
    },
    ymmFilter: (container, aggOptions = null) => {
      const ymmValue = YMM.getYMMValue();
      container.lastQuery = JSON.stringify(ymmValue);
      const { size, page } = container;
      const from = (page || 0) * (size || 24);
      const filters = getYMMFilters(container);
      const sort = getSortQuery(container);
      const should = [];
      const must = [
        {
          nested: {
            path: "metafields.mra_hide_on_store",
            query: {
              bool: {
                must_not: { match: { "metafields.mra_hide_on_store": "Hide" } }
              }
            }
          }
        }
      ];
      const isSelectingYMM = aggOptions?.nextYMMName != null;
      if (isSelectingYMM || filters.fitments.includes("Vehicle Specific")) {
        const ymmMust = [];
        for (const key of ["year", "make", "model"]) {
          if (aggOptions?.nextYMMName === key)
            break;
          const value = ymmValue[key];
          if (value != null && value.trim() !== "") {
            ymmMust.push({ match: { [`ymms.${key}`]: value } });
          }
        }
        if (ymmMust.length > 0) {
          should.push({
            nested: {
              path: "ymms",
              query: {
                bool: {
                  must: ymmMust
                }
              }
            }
          });
        }
      }
      const hasVehicleSpecificFitmentSelected = filters.fitments.includes("Vehicle Specific");
      const hasUniversalFitmentSelected = filters.fitments.includes("Universal");
      YMM.tryUniveral(!(hasVehicleSpecificFitmentSelected && !hasUniversalFitmentSelected));
      if (!isSelectingYMM) {
        if (hasUniversalFitmentSelected) {
          should.push({
            nested: {
              path: "metafields.ymma_fitment",
              query: {
                bool: {
                  must: { match: { "metafields.ymma_fitment.value": "Universal" } }
                }
              }
            }
          });
        }
      }
      for (const [optionName, optionValues] of Object.entries(filters.productMetafields)) {
        must.push({
          nested: {
            path: "metafields." + optionName,
            query: {
              bool: {
                must: optionValues.map((item) => {
                  return {
                    match: {
                      [`metafields.${optionName}.value`]: item
                    }
                  };
                })
              }
            }
          }
        });
      }
      if (!isSelectingYMM) {
        const collectionId = container?.dataset?.collectionId;
        if (collectionId != null && collectionId.trim() !== "") {
          must.push({
            nested: {
              path: "collections",
              query: {
                bool: {
                  must: [
                    { match: { "collections.id": container.dataset.collectionId } }
                  ]
                }
              }
            }
          });
        }
        for (const [optionName, optionValues] of Object.entries(filters.variantsSelectedOptions)) {
          must.push({
            nested: {
              path: "variants.selectedOptions",
              query: {
                bool: {
                  must: [
                    { term: { "variants.selectedOptions.name": optionName } },
                    { terms: { "variants.selectedOptions.value": optionValues } }
                  ]
                }
              }
            }
          });
        }
        ;
        for (const [optionName, optionValues] of Object.entries(filters.variantMetafieldOptions)) {
          must.push({
            nested: {
              path: "variants.metafields." + optionName,
              query: {
                bool: {
                  must: [
                    {
                      terms: {
                        [`variants.metafields.${optionName}.value`]: optionValues
                      }
                    }
                  ]
                }
              }
            }
          });
        }
        if (filters.variantsPrice?.lte != null || filters.variantsPrice?.gte != null) {
          must.push({
            nested: {
              path: "variants",
              query: {
                bool: {
                  must: [
                    { range: { "variants.price": filters.variantsPrice } }
                  ]
                }
              }
            }
          });
        }
        if (filters.productTypes.length > 0) {
          must.push({
            terms: { productType: filters.productTypes }
          });
        }
        if (filters.vendor.length > 0) {
          must.push({
            terms: { vendor: filters.vendor }
          });
        }
      }
      const query = {
        bool: {
          should,
          minimum_should_match: should.length === 0 ? void 0 : 1,
          must
        }
      };
      const aggs = {};
      if (aggOptions?.include) {
        aggs["variants"] = {
          nested: {
            path: "variants"
          },
          aggs: {
            available_ranges: {
              range: {
                field: "variants.inventoryQuantity",
                ranges: [
                  { to: 1, key: "Out of stock" },
                  { from: 1, key: "In stock" }
                ]
              }
            },
            min_price: { min: { field: "variants.price" } },
            max_price: { max: { field: "variants.price" } }
          }
        };
        aggs["ymma_fitments"] = {
          nested: {
            path: "metafields.ymma_fitment"
          },
          aggs: {
            all_values: {
              terms: { field: "metafields.ymma_fitment.value" }
            }
          }
        };
        for (const el of document.querySelectorAll('[data-filter-type="product_variant"]')) {
          const { filterOptionName } = el.dataset;
          aggs[filterOptionName] = {
            nested: {
              path: "metafields." + filterOptionName
            },
            aggs: {
              all_values: {
                terms: { field: "metafields." + filterOptionName + ".value" }
              }
            }
          };
        }
        for (const el of document.querySelectorAll('[data-filter-type="variant_option"]')) {
          const { filterOptionName } = el.dataset;
          aggs[filterOptionName] = {
            nested: {
              path: "variants.selectedOptions"
            },
            aggs: {
              all_values: {
                filter: {
                  term: { "variants.selectedOptions.name": filterOptionName }
                },
                aggs: {
                  all_possible_values: {
                    terms: { field: "variants.selectedOptions.value", size: 50 }
                  }
                }
              }
            }
          };
        }
        for (const el of document.querySelectorAll('[data-filter-type="variant_metafield"]')) {
          const { filterOptionName } = el.dataset;
          aggs[filterOptionName] = {
            nested: {
              path: "variants.metafields." + filterOptionName
            },
            aggs: {
              all_values: {
                terms: {
                  field: `variants.metafields.${filterOptionName}.value`
                }
              }
            }
          };
        }
        aggs["product_types"] = {
          terms: { field: "productType", size: 50 }
        };
        aggs["product_vendors"] = {
          terms: { field: "vendor", size: 50 }
        };
        if (isSelectingYMM) {
          aggs["ymm_values"] = {
            nested: {
              path: "ymms"
            },
            aggs: {
              all_values: {
                terms: { field: `ymms.${aggOptions.nextYMMName}`, size: 1e3 }
              }
            }
          };
        }
      }
      return {
        _source: {
          exclude: ["ymms.*"]
        },
        from,
        size: aggOptions?.noResults ? 0 : size,
        query,
        aggs,
        sort
      };
    },
    renderResult: function(hits, template) {
      const resultArray = [];
      const productTemplate = template;
      if (!hits.hits.length) {
        return false;
      }
      let HTML = "";
      hits.hits.forEach(({ _source }) => {
        const parse = new DOMParser();
        let html = productTemplate;
        const { title, handle, images: [image], variants, metafields, vendor } = _source;
        const { reviews_rating, reviews_rating_count, boost_tagline, boost_clp_promo } = metafields;
        const priceList = variants.map((i) => i.price);
        priceList.sort((a, b) => {
          return a < b;
        });
        const price = priceList[0] || 0;
        let review = 0;
        let reviewCount = 0;
        if (reviews_rating) {
          reviewCount = Math.round(+reviews_rating_count.value);
          review = JSON.parse(reviews_rating.value).value;
        }
        const array = [
          {
            key: "title",
            value: title
          },
          {
            key: "vendor",
            value: vendor
          },
          {
            key: "handle",
            value: handle
          },
          {
            key: "image",
            value: image?.url || "https://cdn.shopify.com/s/files/1/0601/4527/0921/t/10/assets/default-image.jpg?v=1692203040"
          },
          {
            key: "imageWidth",
            value: image?.width || 900
          },
          {
            key: "imageHeight",
            value: image?.height || 900
          },
          {
            key: "price",
            value: Intl.NumberFormat("en", { style: "currency", currency: "USD" }).format(price)
          },
          {
            key: "reviewCount",
            value: reviewCount
          },
          {
            key: "review",
            value: review
          },
          {
            key: "boost_tagline",
            value: boost_tagline?.value || ""
          },
          {
            key: "isFirstVariantAvailable",
            value: variants[0].availableForSale
          },
          {
            key: "isFirstVariantId",
            value: variants[0].id
          },
          {
            key: "variantJSON",
            value: JSON.stringify(variants)
          }
        ];
        array.forEach((item) => {
          const regex = `{{ ${item.key} }}`;
          html = html.replaceAll(regex, item.value);
        });
        const div = document.createElement("div");
        div.innerHTML = html;
        HTML += div.firstElementChild.outerHTML;
      });
      return HTML;
    },
    tryUniveral: (value) => {
      document.querySelector(".jsTryUniversal")?.toggleAttribute("hidden", value);
    }
  };
  function getYMMSelectorQueries(param = "year", selectors = []) {
    const terms = !selectors.length ? [] : selectors.map((item) => {
      return item.value && {
        "term": {
          [`ymms.${item.name}`]: item.value
        }
      };
    });
    let query = {
      "size": 0,
      "query": {
        "nested": {
          "path": "ymms",
          "query": {
            "bool": {
              "must": terms
            }
          }
        }
      },
      "aggs": {
        "ymms": {
          "nested": {
            "path": "ymms"
          },
          "aggs": {
            "model_terms": {
              "filter": {
                "bool": {
                  "must": terms
                }
              },
              "aggs": {
                "models": {
                  "composite": {
                    "size": 1e3,
                    "sources": [
                      {
                        "model": {
                          "terms": {
                            "field": `ymms.${param}`
                          }
                        }
                      }
                    ]
                  }
                }
              }
            }
          }
        }
      }
    };
    return query;
  }

  // app/scripts/filter.js
  var Filter = class {
    constructor(container, config) {
      this.container = container;
      this.field1 = container.querySelector('[data-filter="1"]');
      this.field2 = container.querySelector('[data-filter="2"]');
      this.field3 = container.querySelector('[data-filter="3"]');
      this.field4 = container.querySelector('[data-filter="4"]');
      this.errorField2 = this.field2.querySelector(".js-filter-error");
      this.errorField3 = this.field3.querySelector(".js-filter-error");
      this.field1_title = theme.fields.field1;
      this.field2_title = theme.fields.field2;
      this.field3_title = theme.fields.field3;
      this.field4_title = theme.fields.field4;
      this.filterElm = container.querySelector(".js-filter-selector");
      this.blurElements = container.querySelectorAll(".js-blur");
      this.btnNextStep = container.querySelector(".js-next-step");
      this.btnKeepExploring = container.querySelector(".js-keep-exploring");
      this.lastFilterElm = container.querySelector(".js-last-selector");
      this.btnSelect = container.querySelector(".js-btn-select");
      this.btnClose = container.querySelector(".js-btn-close");
      this.btnClearFilter = container.querySelector(".js-btn-clear");
      this.addToGarageBtns = container.querySelectorAll(".js-btn-add");
      this.btnActions = container.querySelectorAll(".btn-action");
      this.successIcons = container.querySelectorAll(".js-icon-success");
      this.filterContainer = container.querySelectorAll(".js-desk-filter-container");
      this.isModal = !!config ? config.isModal : false;
      this.isMobile = !!config ? config.isMobile : false;
      (async () => {
        const q = this.getYMMSelectorQueries();
        const { aggregations } = await YMM.ymmAPI(q);
        const data = this.handleYMMData(aggregations);
        this.init(data);
        this.data = data;
      })();
      this.initEventShowContent(this.btnSelect, this.btnClose);
      document.addEventListener("changeVehicle", ({ detail }) => {
        if (!detail) {
          this.resetField(this.field1);
          this.resetField(this.field2);
          this.resetField(this.field3);
          this.resetField(this.field4);
          this.initField(this.field1, this.data, this.field1_title);
          this.lastFilterElm.addClass("d-none");
          this.filterElm.removeClass("d-none");
        } else {
          this.lastFilterElm.querySelector(".value").innerHTML = detail.split("__").join(" ");
          if (theme.myGarage && theme.myGarage.query.includes(detail)) {
            this.btnActions.forEach((e) => e.addClass("disabled"));
            this.successIcons.forEach((e) => e.removeClass("d-none"));
          } else {
            this.btnActions.forEach((e) => e.removeClass("disabled"));
            this.successIcons.forEach((e) => e.addClass("d-none"));
          }
          !this.isModal && this.lastFilterElm.removeClass("d-none");
          this.filterElm.addClass("d-none");
        }
      });
      let _this = this;
      container.querySelectorAll(".js-title").forEach((elm) => {
        let filterOptions = elm.closest(".js-item").querySelector(".filter-options");
        elm.addEvent("keydown", function(event) {
          this.resultNew = elm.closest(".js-item").querySelectorAll(".option:not(.empty):not(.d-none)");
          this.resultNew.forEach((e) => e.removeClass("is-highlight"));
          if (event.keyCode == 40) {
            if (this.selectedRow == null || this.selectedRow == void 0) {
              this.selectedRow = 0;
            } else if (this.selectedRow >= this.resultNew.length - 1) {
              this.selectedRow = 0;
            } else {
              this.selectedRow = +this.selectedRow + 1;
            }
            this.resultNew[this.selectedRow].addClass("is-highlight");
            _this.checkSelectedResultVisible(filterOptions, this.resultNew[this.selectedRow]);
          } else if (event.keyCode == 38) {
            if (this.selectedRow == null || this.selectedRow == void 0) {
              this.selectedRow = this.resultNew.length - 1;
            } else if (this.selectedRow <= 0) {
              this.selectedRow = this.resultNew.length - 1;
            } else {
              this.selectedRow = +this.selectedRow - 1;
            }
            this.resultNew[this.selectedRow].addClass("is-highlight");
            _this.checkSelectedResultVisible(filterOptions, this.resultNew[this.selectedRow]);
          } else if (event.keyCode == 13) {
            event.preventDefault();
            let result = this.resultNew[this.selectedRow];
            !!result && result.click();
            this.selectedRow = -1;
          }
        });
      });
    }
    initEventShowContent(openFilterElement, closeFilterElement) {
      if (!openFilterElement)
        return;
      let _this = this;
      openFilterElement.addEvent("click", function() {
        this.addClass("d-none");
        if (this.nextElementSibling && this.nextElementSibling.hasClass("js-btn-close")) {
          this.nextElementSibling.removeClass("d-none");
        } else {
          this.closest(".js-filter-selector").querySelector(".js-btn-close").removeClass("d-none");
        }
        _this.container.querySelector(".js-field-list").addClass("is-open");
      });
      closeFilterElement.addEvent("click", function() {
        if (AT.getCookie("arn-filter")) {
          let label = _this.lastFilterElm.querySelector(".value");
          let lastFilter = AT.getCookie("arn-filter");
          label.innerHTML = lastFilter.split("__").join(" ");
          _this.lastFilterElm.removeClass("d-none");
          _this.filterElm.addClass("d-none");
        } else {
          this.addClass("d-none");
          if (this.previousElementSibling && this.previousElementSibling.hasClass("js-btn-select")) {
            this.previousElementSibling.removeClass("d-none");
          } else {
            this.closest(".js-filter-selector").querySelector(".js-btn-select").removeClass("d-none");
          }
          this.closest(".js-filter-selector").querySelector(".js-field-list").removeClass("is-open");
        }
      });
    }
    checkSelectedResultVisible(t, e) {
      if (!e)
        return;
      var n = t.getBoundingClientRect(), s = e.getBoundingClientRect();
      s.top < n.top ? t.scrollTop -= n.top - s.top : s.bottom > n.bottom && (t.scrollTop += s.bottom - n.bottom);
    }
    async init(data) {
      let _this = this;
      this.initField(this.field1, data, this.field1_title);
      if (AT.getCookie("arn-filter")) {
        let label = this.lastFilterElm.querySelector(".value");
        let lastFilter = AT.getCookie("arn-filter");
        let dataFilter = lastFilter.split("__");
        label.innerHTML = dataFilter.join(" ");
        label.dataset.href = theme.routes.roofBedRacksCollectionUrl;
        this.blurElements.forEach((e) => e.removeClass("is-blur"));
        document.querySelectorAll(".field-item.js-item").forEach((e) => e.removeClass("disabled"));
        this.lastFilterElm.removeClass("d-none");
        let items = this.container.querySelectorAll(".js-item:not(.d-none)");
        let field2Data;
        let filterSelectors = [];
        for (var i = 0; i < dataFilter.length; i++) {
          const filterValue = dataFilter[i];
          const index = i + 1;
          const item = items[i];
          item.dataset.value = filterValue;
          item.querySelector(".js-title").value = filterValue;
          const input = item.querySelector(".jsYMMSelector");
          input.value = filterValue;
          filterSelectors.push(input);
          let filterIndex = `field${index + 1}`;
          let filterTitle = `${filterIndex}_title`;
          const q = this.getYMMSelectorQueries(this[filterTitle].toLowerCase(), filterSelectors);
          const { aggregations } = await YMM.ymmAPI(q);
          const newData = this.handleYMMData(aggregations);
          if (this[filterTitle].toLowerCase().length) {
            this.initField(this[filterIndex], newData, this[filterTitle]);
          }
        }
        if (theme.myGarage && theme.myGarage.query.includes(lastFilter)) {
          _this.btnActions.forEach((e) => e.addClass("disabled"));
          _this.successIcons.forEach((e) => e.removeClass("d-none"));
        }
        let string = [
          this.field1.dataset.value,
          this.field2.dataset.value,
          this.field3.dataset.value,
          this.field4.dataset.value
          // id,
        ];
        _this.btnNextStep.dataset.string = string.join("__");
        document.addEventListener("garageChanged", ({ detail: query }) => {
          if (query.includes(AT.getCookie("arn-filter"))) {
            _this.btnActions.forEach((e) => e.addClass("disabled"));
          } else {
            _this.btnActions.forEach((e) => e.removeClass("disabled"));
          }
        });
        if (!!this.container.querySelector(".js-filter-submit-button")) {
          this.container.querySelector(".js-filter-submit-button").removeClass("d-none");
        }
      } else {
        this.filterElm.removeClass("d-none");
        this.blurElements.forEach((e) => e.addClass("is-blur"));
      }
      if (!!this.container.querySelector(".js-filter-submit-button")) {
        this.container.querySelector(".js-filter-submit-button").addEvent("click", () => {
          let filterData = AT.getCookie("arn-filter");
          document.dispatchEvent(new CustomEvent("changeVehicle", { detail: filterData }));
          this.container.closest(".modal")?.removeClass("is-open");
          if (this.container.closest("ymm-popup")) {
            window.location.reload();
          }
        });
      }
      this.btnNextStep.addEvent("click", function() {
        const id = this.dataset.id;
        const string = this.dataset.string;
        YMM.ymmSave(this.closest(".js-field-list").querySelectorAll(".jsYMMSelector"));
        switch (theme.template.name) {
          case "collection":
            window.location.href = theme.routes.roofBedRacksCollectionUrl;
            break;
          case "product":
            if (_this.isModal) {
              document.dispatchEvent(new CustomEvent("changeVehicle", { detail: string }));
              _this.filterElm.addClass("d-none");
              _this.lastFilterElm.removeClass("d-none");
              _this.lastFilterElm.querySelector(".value").innerHTML = string.split("__").join(" ");
              document.dispatchEvent(new CustomEvent("changeVehicle", { detail: string }));
              break;
            }
          default:
            window.location.href = theme.routes.roofBedRacksCollectionUrl;
            break;
        }
      });
      this.addToGarageBtns.forEach((element) => {
        element.addEvent("click", () => {
          if (!_this.checkData())
            return;
          element.addClass("pending");
          let lastFilter = AT.getCookie("arn-filter").split("__").join("_");
          let queryNew;
          if (theme.myGarage && theme.myGarage.query.length > 0) {
            queryNew = [...theme.myGarage.query.split(","), lastFilter].join(",");
          } else {
            queryNew = lastFilter;
          }
          fetch("https://app.advancedcustomfield.com/apps/track-query", {
            method: "post",
            headers: { "Content-Type": "text/plain" },
            body: JSON.stringify({ ...theme.myGarage, query: queryNew }),
            mode: "cors"
          }).then((res) => {
            if (!res.ok) {
              throw Error(res.statusText);
            }
            return res.text();
          }).then((text) => {
            let query = !!text ? JSON.parse(text).metafield.value : "";
            theme.myGarage.query = query;
            document.dispatchEvent(new CustomEvent("garageChanged", { detail: query }));
            document.dispatchEvent(new CustomEvent("addMyGarage", { detail: lastFilter }));
            element.removeClass("pending");
            _this.successIcons.forEach((e) => e.removeClass("d-none"));
          }).catch((err) => {
            console.log(err);
          });
        });
      });
      this.btnClearFilter.addEvent("click", () => {
        AT.deleteCookie("arn-filter");
        document.dispatchEvent(new CustomEvent("changeVehicle", { detail: "" }));
        _this.blurElements.forEach((e) => e.addClass("is-blur"));
        _this.field2.addClass("disabled");
        _this.field3.addClass("disabled");
        [
          this.field1,
          this.field2,
          this.field3,
          this.field4
        ].filter((i2) => i2.querySelector("input").name).forEach((i2) => {
          const key2 = `ymm-${i2.querySelector("input").name}`;
          localStorage.removeItem(key2);
        });
        if (theme.template.name == "collection") {
          window.location.href = location.origin + location.pathname;
        }
      });
      theme.template.name == "collection" && this.btnClose.addEvent("click", () => {
        if (!!AT.getCookie("arn-filter") && !this.container.classList.contains("js-sticky-filter-container")) {
          let id = AT.getCookie("arn-filter").split("__").slice(-1)[0];
          let newURL = window.location.pathname;
          window.location.href = newURL;
        }
        if (!!AT.getCookie("arn-filter") && this.container.classList.contains("js-sticky-filter-container")) {
          let container = document.querySelector(".section-filter-mobile .js-sticky-filter-container");
          let label = container.querySelector(".js-last-selector").querySelector(".value");
          let lastFilter = AT.getCookie("arn-filter");
          label.innerHTML = lastFilter.split("__").join(" ");
          container.querySelector(".js-last-selector").removeClass("d-none");
          container.querySelector(".js-filter-selector").addClass("d-none");
        }
      });
      this.lastFilterElm.querySelector(".js-btn-change").addEvent("click", () => {
        _this.btnSelect.click();
        _this.lastFilterElm.addClass("d-none");
        _this.filterElm.removeClass("d-none");
      });
      !!this.btnKeepExploring && this.btnKeepExploring.addEvent("click", function() {
        if (!_this.checkData())
          return;
        let label = _this.lastFilterElm.querySelector(".value");
        let lastFilter = AT.getCookie("arn-filter");
        let id = lastFilter.split("__").slice(-1);
        label.innerHTML = lastFilter.split("__").join(" ");
        _this.filterElm.addClass("d-none");
        _this.lastFilterElm.removeClass("d-none");
        let string = [
          _this.field1.dataset.value,
          _this.field2.dataset.value,
          _this.field3.dataset.value,
          _this.field4.dataset.value,
          id
        ];
        switch (theme.template.name) {
          case "collection":
            window.location.href = location.origin + location.pathname;
            break;
            case "product":
              let filterData = AT.getCookie("arn-filter");
              document.dispatchEvent(new CustomEvent("changeVehicle", { detail: filterData }));
              if (_this.isModal) {
                _this.filterElm.addClass("d-none");
                _this.lastFilterElm.removeClass("d-none");
                _this.lastFilterElm.querySelector(".value").innerHTML = string.split("__").join(" ");
                document.dispatchEvent(new CustomEvent("changeVehicle", { detail: string }));
                break;
              }
            default:
              break;
        }
      });
      document.dispatchEvent(new CustomEvent("filter-init"));
    }
    initField(elm, data, key) {
      let _this = this;
      let titlePlaceholder = elm.querySelector(".js-title");
      let optionsElm = elm.querySelector(".filter-options");
      let selectOptionsElm = elm.querySelector("select.select-filter-options");
      let options = data;
      if (key === "Year") {
        options.sort((a, b) => b - a);
      } else {
        options.sort((a, b) => a.localeCompare(b));
      }
      options.forEach((item, index) => {
        let option = document.createElement("option");
        if (!!item) {
          option.setAttribute("value", item);
          if (this.field4_title == "" && key === "Model") {
            data.forEach((_item) => {
              if (_item.Model == item) {
                option.setAttribute("data-option-id", _item.ID);
              }
            });
          }
          option.innerHTML = item;
        } else {
          option.setAttribute("value", "Blank");
          option.innerHTML = "Blank";
        }
        selectOptionsElm.append(option);
      });
      optionsElm.innerHTML = options.reduce((accu, value, index) => {
        let option = document.createElement("div");
        option.addClass("option");
        if (!!value) {
          option.setAttribute("data-value", value);
          if (this.field4_title == "" && key === "Model") {
            data.forEach((_item) => {
              if (_item.Model == value) {
                option.setAttribute("data-option-id", _item.ID);
              }
            });
          }
          option.innerHTML = value;
          accu += option.outerHTML;
        } else {
          option.setAttribute("data-value", "Blank");
          option.innerHTML = "Blank";
          accu = option.outerHTML + accu;
        }
        return accu;
      }, "");
      let emptyDiv = document.createElement("div");
      emptyDiv.addClass("option", "empty", "d-none");
      emptyDiv.innerHTML = "Sorry, nothing found";
      optionsElm.appendChild(emptyDiv);
      optionsElm.children.addEvent("click", (e) => {
        e.stopPropagation();
        let value = e.target.dataset.value;
        optionsElm.removeClass("active");
        !!document.querySelector(".js-filter-selector .tns-ovh") && document.querySelector(".js-filter-selector .tns-ovh").removeClass("active");
        elm.setAttribute("data-value", value);
        titlePlaceholder.value = value;
        titlePlaceholder.dataset.placeholder = value;
        this.change(elm.dataset.filter, data, e);
      });
      elm.addEvent("click", function(e) {
        e.target.closest(".js-item").querySelector(".js-title").addEvent("input", function(event) {
          let search_term = event.target.value.toLowerCase();
          let results = optionsElm.querySelectorAll(".option:not(.empty)");
          AT.debounce(() => {
            let result = [...results].filter((item) => {
              if (item && item.dataset.value.toLowerCase().includes(search_term)) {
                item.removeClass("d-none");
                return true;
              } else {
                item.addClass("d-none");
                return false;
              }
            });
            result.length > 0 ? optionsElm.querySelectorAll(".empty").addClass("d-none") : optionsElm.querySelectorAll(".empty").removeClass("d-none");
          }, 500)();
        });
        this.selectedRow = -1;
        optionsElm.addClass("active");
        !!document.querySelector(".js-filter-selector .tns-ovh") && document.querySelector(".js-filter-selector .tns-ovh").addClass("active");
      });
      selectOptionsElm.addEvent("change", (e) => {
        let value = e.target.value;
        elm.setAttribute("data-value", value);
        this.change(elm.dataset.filter, data, e, "select");
      });
      document.addEventListener("mouseup", function(e) {
        if (!elm.contains(e.target)) {
          optionsElm.removeClass("active");
          !!document.querySelector(".js-filter-selector .tns-ovh") && document.querySelector(".js-filter-selector .tns-ovh").removeClass("active");
          _this.checkData();
        }
      });
    }
    async change(index, data, event, style) {
      switch (index) {
        case "1": {
          const selectors = [this.field1.querySelector(".jsYMMSelector")];
          const q = this.getYMMSelectorQueries(this.field2_title.toLowerCase(), selectors);
          const { aggregations } = await YMM.ymmAPI(q);
          const newData = this.handleYMMData(aggregations);
          this.resetField(this.field2);
          this.resetField(this.field3);
          this.resetField(this.field4);
          this.initField(this.field2, newData, this.field2_title);
          this.field2.removeClass("disabled");
          this.field2.querySelector(".js-title").click();
          this.field2.querySelector(".js-title").focus();
          this.field2.querySelector(".filter-options").addClass("active");
          break;
        }
        case "2": {
          const selectors = [this.field1.querySelector(".jsYMMSelector"), this.field2.querySelector(".jsYMMSelector")];
          const q = this.getYMMSelectorQueries(this.field3_title.toLowerCase(), selectors);
          const { aggregations } = await YMM.ymmAPI(q);
          const newData = this.handleYMMData(aggregations);
          this.resetField(this.field3);
          this.resetField(this.field4);
          this.initField(this.field3, newData, this.field3_title);
          this.field3.removeClass("disabled");
          this.field3.querySelector(".js-title").click();
          this.field3.querySelector(".js-title").focus();
          this.field3.querySelector(".filter-options").addClass("active");
          break;
        }
        case "3": {
          if (this.field4_title != "") {
            const selectors = [this.field1.querySelector(".jsYMMSelector"), this.field2.querySelector(".jsYMMSelector"), this.field3.querySelector(".jsYMMSelector")];
            const q = this.getYMMSelectorQueries(this.field4_title.toLowerCase(), selectors);
            const { aggregations } = await YMM.ymmAPI(q);
            const newData = this.handleYMMData(aggregations);
            this.resetField(this.field4);
            if (newData.length === 1) {
              if (!newData[0][this.field4_title]) {
                this.field4.addClass("d-none");
                this.redirect(newData[0]["ID"]);
              } else {
                this.field4.removeClass("d-none");
                this.initField(this.field4, newData, this.field4_title);
                this.field4.querySelector(".filter-options").children[0].click();
                return;
              }
            } else {
              this.initField(this.field4, newData, this.field4_title);
              this.field4.removeClass("disabled");
              this.field4.querySelector(".filter-options").addClass("active");
              this.field4.removeClass("d-none");
            }
          } else {
            let id;
            style == "select" ? id = event.target.options[event.target.selectedIndex].getAttribute("data-option-id") : id = event.target.dataset.optionId;
            this.redirect(id);
          }
          break;
        }
        case "4": {
          let id = data.find((item) => item[this.field4_title] === this.field4.dataset.value)["ID"];
          this.redirect(id);
          break;
        }
      }
      this.checkData();
    }
    resetField(elm) {
      let title = elm.querySelector(".js-title");
      elm.setAttribute("data-value", "");
      title.value = "";
    }
    redirect(id) {
      let string = [
        this.field1.dataset.value,
        this.field2.dataset.value,
        this.field3.dataset.value,
        this.field4.dataset.value,
        id
      ].filter(Boolean).join("__");
      if (!!AT.getCookie("arn-filter"))
        AT.deleteCookie("arn-filter");
      AT.setCookie("arn-filter", string, 1);
      [
        this.field1,
        this.field2,
        this.field3,
        this.field4
      ].filter((i) => i.querySelector("input").name).forEach((i) => {
        const key2 = `ymm-${i.querySelector("input").name}`;
        const value2 = String(i.dataset.value);
        localStorage.setItem(key2, value2);
      });
      if (!!this.container.querySelector(".js-filter-submit-button")) {
        this.container.querySelector(".js-filter-submit-button").removeClass("d-none");
      }
      if (theme.myGarage && theme.myGarage.query.includes(string)) {
        this.btnActions.forEach((e) => e.addClass("disabled"));
        this.successIcons.forEach((e) => e.removeClass("d-none"));
      } else {
        this.btnActions.forEach((e) => e.removeClass("disabled"));
        this.successIcons.forEach((e) => e.addClass("d-none"));
      }
      if (this.isMobile) {
        document.dispatchEvent(new CustomEvent("selectedVehicle", { detail: string }));
      }
      this.blurElements.forEach((e) => e.removeClass("is-blur"));
      if (theme.template.name == "collection") {
        document.querySelector(".js-find-parts")?.removeAttribute("disabled");
      }
      this.btnNextStep.dataset.id = id;
      this.btnNextStep.dataset.string = string;
    }
    checkData() {
      let isTrue = false;
      if (AT.getCookie("arn-filter") && !!this.errorField2 && !!this.errorField3) {
        "" == this.field2.dataset.value ? (this.errorField2.removeClass("d-none"), isTrue = false) : (this.errorField2.addClass("d-none"), isTrue = true);
        "" == this.field3.dataset.value ? (this.errorField3.removeClass("d-none"), isTrue = false) : (this.errorField3.addClass("d-none"), isTrue = true);
      }
      return isTrue;
    }
    handleYMMData(data) {
      const item = data.ymms.model_terms.models;
      const { buckets } = item;
      return buckets.map((i) => i.key.model);
      const options = buckets.map((b) => {
        const value2 = b.key.model;
        return `<option value="${value2}"${String(b.key) === selectedValue ? " selected" : ""}>${value2}</option>`;
      });
      const html = [initOption, ...options].join("");
      for (const select of document.querySelectorAll(`.ymm-${fieldName}-select`)) {
        select.innerHTML = html;
        select.removeAttribute("disabled");
      }
    }
    getYMMSelectorQueries(...arg) {
      const q = getYMMSelectorQueries(...arg);
      return q;
    }
  };
  window.Filter = Filter;
})();
